module.exports = __webpack_public_path__ + "img/Illustration-13.9f439cc0.png";